'use strict';

function __detectSessionID() {
	let sessionId = '';
	if (window.location.toString().match(/SESS_ID=(\d+)/)) {
		sessionId = RegExp.$1;
	}
	return sessionId;
}

let fancybox = {};

let popup = {
	html: '<div class="popup js-popup">'
	+ '<div class="popup__top">'
	+ '<div class="popup__inner m--nopadding">'
	+ '<div class="popup__block">'
	+ '<a href="#" class="popup__close js-popup__close"></a>'
	+ '</div>'
	+ '</div>'
	+ '</div>'
	+ '<div class="popup__inner js-popup__content"></div>'
	+ '</div>',
	selector: '.js-popup'
};

let ajax = {
    type: 'post',
    url: '/json/',
    dataType: 'json',
    timeout: 10000,
    traditional: true,
    SESSION_ID: __detectSessionID(),
    loader_selector: '.loader',
    loader: '<div class="loader"></div>'
};

let yaCounter = 'yaCounter0';

let breakpoints = {
	xxl: Infinity,
	xl: 1620,
	l: 1280,
	m: 1000,
	s: 780,
	xs: 600,
	xxs: 420
};

let interfaceName = document.body.dataset['interface'];

export {
	fancybox,
	ajax,
	breakpoints,
	yaCounter,
	interfaceName,
	popup,
};
